import type { IconName } from "common/named-icons";
import { getNamedIcon } from "common/named-icons";
import { styled } from "../../../styled-components";

const ToggleIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    /* I like big click areas and I cannot lie */
    padding: 8px;
    margin: -8px;

    filter: drop-shadow(0px 0px 4px #00000040);
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    readonly icon: IconName;
}

const ToggleIconOverlayView: React.FunctionComponent<Props> = p => {
    const { icon, children, ...rest } = p;
    const Icon = getNamedIcon(p.icon);
    return (
        <ToggleIcon {...rest}>
            <Icon />
        </ToggleIcon>
    );
};
export default ToggleIconOverlayView;
